<div class="notification-item">
  <div
    data-auto-id="performCallbackClick"
    class="notification-item__container"
    (click)="performCallback()"
  >
    <div class="notification-item__label">
      {{ notification()?.label }}
    </div>
  </div>
</div>
